import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Link, Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { NextLink } from '../../../next-link'
import { urlGetRelativeUrl } from '../../../url-handling'
import { recommendationAccessorGetLocalizedProductName } from '../../model/recommendationAccessorGetLocalizedProductName'
import { recommendationAccessorGetLocalizedProductUrl } from '../../model/recommendationAccessorGetLocalizedProductUrl'
import { recommendationAccessorGetSponsoredProductLink } from '../../model/recommendationAccessorGetSponsoredProductLink'
import { useRecommendationWidgetContext } from '../RecommendationAreaProvider'

const LinkSlot = prepareForSlot(NextLink)

type RecommendationProductNameProps = {
  className?: string
  onClick?: () => void
  product?: GkAirRecommendedProductDataWeb
}

export const RecommendationProductName: FC<RecommendationProductNameProps> = ({
  className,
  onClick,
  product,
}) => {
  const { locale } = useGlobalConfigContext()
  const { adServerMetadata } = useRecommendationWidgetContext()

  if (!product) {
    return (
      <div className="flex flex-col items-center gap-2">
        <Skeleton className="w-full" />
        <Skeleton className="w-full" />
        <Skeleton className="w-3/4" />
      </div>
    )
  }

  const sponsoredProductLink = recommendationAccessorGetSponsoredProductLink({
    adServerMetadata,
    product,
  })

  const productName = recommendationAccessorGetLocalizedProductName({
    locale,
    product,
  })

  return (
    <Link
      className={clsx('recommendations-product-card-name', className)}
      data-analytics="recommendations-item-title"
      data-qa-id={`form-product-slider-${product.UID}-link-button`}
      href={
        sponsoredProductLink ??
        urlGetRelativeUrl(
          recommendationAccessorGetLocalizedProductUrl({
            locale,
            product,
          }),
        ) ??
        '/'
      }
      onClick={onClick}
      rel={sponsoredProductLink ? 'nofollow noopener' : undefined}
      slots={{ root: LinkSlot }}
      title={productName}
    >
      {productName}
    </Link>
  )
}
